import withFormikSelect from '../withSelectFormik';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import options from './options';

export default withFormikSelect(withOptionsSelectValueInitById(options, options[0]));
